import React, { useState } from 'react'
import * as FaIcons from 'react-icons/fa'
import * as AiIcons from 'react-icons/ai'
import { Link, useNavigate } from 'react-router-dom'
import { SidebarData } from './SidebarData'
import { IconContext } from 'react-icons'
import { AiFillHome } from 'react-icons/ai'
import './Sidebar.css'
import { BsPersonCircle } from 'react-icons/bs'
import logo from '../../../assets/images/inferenz-logo.svg'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

export const Sidebar = () => {
  const navigate = useNavigate()
  const [sidebar, setSidebar] = useState(false)

  const showSidebar = () => setSidebar(!sidebar)

  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <div className="container navbar">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars
              onClick={showSidebar}
              style={{ color: '#042049' }}
            />
          </Link>

          <Tippy content="Switch Portal" theme="bootstrap">
            <Link to="/portal" className="link" style={{ marginLeft: 'auto' }}>
              <AiFillHome
                style={{
                  width: '25px',
                  height: '25px',
                  marginTop: '0.2rem',
                  marginRight: '1rem',
                  color: '#0d6efd',
                }}
              />{' '}
            </Link>
          </Tippy>
          <Tippy content="My Profile" theme="bootstrap">
            <Link to="/profile" className="link">
              <div>
                <BsPersonCircle
                  style={{
                    width: '25px',
                    height: '25px',
                    marginTop: '0.2rem',
                    marginRight: '1rem',
                    color: '#0d6efd',
                  }}
                />
              </div>
            </Link>
          </Tippy>

          <Link to="/home">
            <img src={logo} alt="logo" className="headerLogo" />
          </Link>
        </div>
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className="navbar-toggle">
              <Link to="#" className="menu-bars">
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {SidebarData.map((item, index) => {
              return (
                <li
                  key={index}
                  className={item.cName}
                  data-bs-target={
                    item.title === 'Logout' ? '#exampleModal' : ''
                  }
                  data-bs-toggle={item.title === 'Logout' ? 'modal' : ''}
                >
                  <Link
                    to={item.path}
                    id={
                      window.location.pathname === item.path
                        ? 'recruiterPath'
                        : ''
                    }
                  >
                    {item.icon}
                    <span style={{ marginLeft: '1rem' }}>{item.title}</span>
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
      </IconContext.Provider>
      <div
        className="modal"
        tabIndex="-1"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to Logout from Intranet ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  logout()
                }}
                data-bs-dismiss="modal"
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
